import { isPlatformBrowser } from '@angular/common';
import {
  type HttpErrorResponse,
  type HttpEvent,
  type HttpHandlerFn,
  type HttpRequest,
} from '@angular/common/http';
import { inject, PLATFORM_ID } from '@angular/core';
import { type Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { SnackbarService } from '../../shared/components/snackbar/snackbar.service';
import { AuthService } from '../services/auth/auth.service';

export function errorInterceptor(
  req: HttpRequest<unknown>,
  next: HttpHandlerFn,
): Observable<HttpEvent<unknown>> {
  const authService = inject(AuthService);
  const snackbarService = inject(SnackbarService);
  const platformId = inject(PLATFORM_ID);

  return next(req).pipe(
    catchError((errorResponse: HttpErrorResponse) => {
      const { status, error } = errorResponse;

      const errorMessage =
        error?.message ||
        'No podemos establecer conexión con el servidor. Por favor, inténtelo de nuevo o contacte al soporte.';

      if (isPlatformBrowser(platformId)) {
        snackbarService.showError(
          error?.title || '¡Ops! Parece que tenemos un problema',
          errorMessage,
          error?.details || [],
        );

        // 401 Unauthorized or 403 Forbidden special case
        if (status === 401 || status === 403) {
          authService.logout();
        }
      }

      return throwError(() => errorResponse);
    }),
  );
}
